import {
  EU_TOPSHOP_BASE_URL,
  EU_STORE_CONFIG,
} from "../../constants/static-constants";

export const getEuRedirectUrl = (geoCountry: string): string => {
  const countryConfig = EU_STORE_CONFIG.find(
    (country) => country.code === geoCountry,
  );

  if (!countryConfig) {
    return EU_TOPSHOP_BASE_URL;
  }

  if (countryConfig.path) {
    return `${EU_TOPSHOP_BASE_URL}/${countryConfig.path}`;
  }

  return EU_TOPSHOP_BASE_URL;
};
